"use client";

import dynamic from "next/dynamic";
import { useEffect, useState, type ReactNode } from "react";

const SplitTransition = dynamic(
  () => import("./SplitTransition").then((m) => ({ default: m.SplitTransition })),
  { ssr: false },
);

/** Mount split-transition only on first input — idle mount wrapped the page in
 *  `100dvh` mid-load and caused ~0.07 CLS on mobile Lighthouse. */
export function DeferredSplitTransition({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const wake = () => setReady(true);
    document.addEventListener("pointerdown", wake, { once: true, capture: true });
    document.addEventListener("keydown", wake, { once: true, capture: true });
    return () => {
      document.removeEventListener("pointerdown", wake, { capture: true });
      document.removeEventListener("keydown", wake, { capture: true });
    };
  }, []);

  if (!ready) return <>{children}</>;
  return <SplitTransition>{children}</SplitTransition>;
}
